import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumToText' })
export class EnumToTextPipe implements PipeTransform {
  transform(text: string): string {
    if (!text) {
      return '';
    }
    return text.replace(/-/g, ' ').replace(/(^|\s)[A-Za-z]/g, (text: string) => text.toUpperCase());
  }
}
